<template>
   <Header header__white="header__white" />
   <Breadcrumb title="Administrativo" subtitle="Administrativo" />
   <CourseSidebarArea />
   <Footer footerPadding="true" />
</template>

<script>
import Header from '../components/Inicio/Header.vue';
import Breadcrumb from '../components/Inicio/Breadcrumb.vue';
import CourseSidebarArea from '../components/Inicio/Administrativo.vue';
import Footer from '../components/Inicio/Footer.vue';

export default {
   name: 'AdministrativoPage',
   components: {
      Header,
      Breadcrumb,
      CourseSidebarArea,
      Footer,
   }
};
</script>
